module.exports = __webpack_public_path__ + "img/Workflow-ability-04.54e355e5.png";